/**
 * @specification
 * Adds role='listitem'.
 */
export var breadcrumbItemBehavior = function breadcrumbItemBehavior() {
  return {
    attributes: {
      root: {
        role: 'listitem'
      }
    }
  };
};
//# sourceMappingURL=breadcrumbItemBehavior.js.map
